import { jsx as _jsx } from "react/jsx-runtime";
import { ApplicationLink, ModuleLink } from '../../links';
export const ModuleOrApplicationLinkRenderer = (param)=>{
    let { value, organization, project, application, type = 'module', moduleWithApplicationPrefix, params } = param;
    const name = value !== null && value !== void 0 ? value : '';
    if (type === 'application' && project) {
        return /*#__PURE__*/ _jsx(ApplicationLink, {
            organization: organization,
            project: project,
            application: name || application,
            query: params,
            children: name || application
        });
    }
    if (type === 'module' && project && application) {
        const moduleLabel = moduleWithApplicationPrefix ? "".concat(application, "/").concat(name) : name;
        return /*#__PURE__*/ _jsx(ModuleLink, {
            organization: organization,
            project: project,
            application: application,
            module: name,
            query: params,
            children: moduleLabel
        });
    }
    return /*#__PURE__*/ _jsx("span", {
        className: "text-sm",
        children: name
    });
};
